import React from 'react';
import { TextTag, Breakpoints } from '@volkswagen-onehub/components-core';
import {
  TextAppearance,
  TextSize,
  TextWeight,
  TextLineHeight,
} from '@vw-marketing/us-components';

import { TextBox } from '../Box';
import { Icon } from '../Icon';
import { CTACircularBorder } from '../StickyBottomNav/styles';
import { NavigationSection } from '../../fetch-data/graphql';
import { useViewport, ViewportType } from '../../hooks/use-viewport';
import {
  NavigationItemContainer,
  NavigationButtonContainer,
  NavigationTextContainer,
  VisibilityContainer,
} from './styles';

interface SlideNavigationProps {
  previous: NavigationSection | null;
  next: NavigationSection | null;
  onChange: (section: NavigationSection | null) => void;
}

export const SlideNavigation = ({
  previous,
  next,
  onChange,
}: SlideNavigationProps) => {
  const viewport = useViewport(Breakpoints.b560, Breakpoints.b1280);
  const isTablet: boolean = viewport === ViewportType.TABLET;

  return (
    <>
      {isTablet ? (
        <>
          <VisibilityContainer $isVisible={!!previous}>
            <NavigationItemContainer>
              <CTACircularBorder
                tag='button'
                emphasis='tertiary'
                aria-label='Previous Section CTA'
                onClick={() => onChange(previous)}
                style={{ marginRight: '16px' }}
              >
                <Icon name='ChevronLeft' ignoreDefaultColor={true} />
              </CTACircularBorder>
              <TextBox
                appearance={TextAppearance.copy200}
                tag={TextTag.span}
                style={{
                  [Breakpoints.default]: {
                    fontSize: TextSize.TextSize16,
                    fontWeight: TextWeight.bold,
                    lineHeight: TextLineHeight.TextLineHeight24,
                  },
                }}
                customStyle={(theme) => ({
                  color: theme.colors.content.active,
                })}
              >
                {previous?.sectionName}
              </TextBox>
            </NavigationItemContainer>
          </VisibilityContainer>

          <VisibilityContainer $isVisible={!!next}>
            <NavigationItemContainer>
              <TextBox
                appearance={TextAppearance.copy200}
                tag={TextTag.span}
                style={{
                  [Breakpoints.default]: {
                    fontSize: TextSize.TextSize16,
                    fontWeight: TextWeight.bold,
                    lineHeight: TextLineHeight.TextLineHeight24,
                  },
                }}
                customStyle={(theme) => ({
                  color: theme.colors.content.active,
                })}
              >
                {next?.sectionName}
              </TextBox>
              <CTACircularBorder
                tag='button'
                emphasis='tertiary'
                aria-label='Next Section CTA'
                onClick={() => onChange(next)}
                style={{ marginLeft: '16px' }}
              >
                <Icon name='ChevronRight' ignoreDefaultColor={true} />
              </CTACircularBorder>
            </NavigationItemContainer>
          </VisibilityContainer>
        </>
      ) : (
        <>
          {next && (
            <NavigationTextContainer>
              <TextBox
                appearance={TextAppearance.copy200}
                tag={TextTag.span}
                style={{
                  [Breakpoints.default]: {
                    fontSize: TextSize.TextSize16,
                    fontWeight: TextWeight.bold,
                    lineHeight: TextLineHeight.TextLineHeight24,
                  },
                }}
              >
                {next
                  ? `Next: ${next.sectionName}`
                  : previous
                    ? `Previous: ${previous.sectionName}`
                    : ''}
              </TextBox>
            </NavigationTextContainer>
          )}
          <NavigationButtonContainer>
            <VisibilityContainer $isVisible={!!previous}>
              <CTACircularBorder
                tag='button'
                emphasis='tertiary'
                aria-label='Previous Section CTA'
                onClick={() => onChange(previous)}
              >
                <Icon name='ChevronLeft' ignoreDefaultColor={true} />
              </CTACircularBorder>
            </VisibilityContainer>
            <VisibilityContainer $isVisible={!!next}>
              <CTACircularBorder
                tag='button'
                emphasis='tertiary'
                aria-label='Next Section CTA'
                onClick={() => onChange(next)}
              >
                <Icon name='ChevronRight' ignoreDefaultColor={true} />
              </CTACircularBorder>
            </VisibilityContainer>
          </NavigationButtonContainer>
        </>
      )}
    </>
  );
};
